











































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import ModalMobile from '@/shared/components/ModalMobile/ModalMobile.vue';
import Input from '@/shared/components/Inputs/Input.vue';
import Field from '@/shared/components/Field/Field.vue';

import { passwordRecovery } from '@/api/resources/customer';
import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';
import { sendInteractEvent } from '@/helpers/events';

@Component({
  components: {
    ModalMobile,
    Input,
    Field,
  }
})
export default class ForgotPasswordMobile extends Vue {
  @Prop() private readonly username!: any;

  private validator = new Validator;
  private callbackType: string = '';

  private form: any = {
    fields: {
      username: this.username,
    },
    states: {
      loading: false,
    },
    errors: this.validator.errors,
  };

  private modalOpen = false;

  @Watch('modalOpen', { immediate: true })
  private onPasswordRecoveryClick() {
    if (this.modalOpen) {
      sendInteractEvent({ action: EInteractEventTrackerAction.CHK_PASSWORD_RECOVERY });
    }
  }

  private validateForm() {
    return new Promise(async (resolve: any, reject) => {
      const result = await this.validator.validateAll({
        usernameRecover: this.form.fields.username,
      });

      (result)
        ? resolve()
        : reject();
    });
  }

  private showCallbackModal(type: string) {
    this.callbackType = type;
  }

  private async submitForm() {
    this.form.states.loading = true;

    sendInteractEvent({ action: EInteractEventTrackerAction.CHK_PASSWORD_RECOVERY });

    try {
      await this.validateForm();
      const { data: response } = await passwordRecovery(this.form.fields.username);

      sendInteractEvent({
        action: EInteractEventTrackerAction.CHK_PASSWORD_RECOVERY_SUCCESS,
        attributes: {
          return_code: response.status,
          return_message: 'OK',
        },
      });

      this.showCallbackModal('success');
    } catch (error) {
      (error && error.response.status) && this.showCallbackModal('error');

      sendInteractEvent({
        action: EInteractEventTrackerAction.CHK_PASSWORD_RECOVERY_FAILED,
        attributes: {
          return_code: error.response.status,
          return_message: error.response.data && error.response.data.message,
        },
      });
    } finally {
      this.form.states.loading = false;
    }
  }

  private created() {
    this.validator.attach({
      name: 'usernameRecover',
      rules: 'required|username|userExists',
    });
  }

  toggle(){
    const mobileModal = this.$refs.mobileModal as any;
    mobileModal.toggle();
  }

  get isCallback(): boolean{
    return !!this.callbackType;
  }

  private destroyed() {
    this.validator.reset();
  }
}
